import { styled } from "@mui/material/styles";
import { Box, TableCell } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const ValidationOverviewBox = styled(Box)(({ theme, passed }) => ({
    display: "flex",
    alignItems: "center",
    border: `2px solid ${passed ? theme.palette.jigsaw.green : theme.palette.jigsaw.red}`,
    backgroundColor: passed ? theme.palette.jigsaw.lighterGreen : theme.palette.jigsaw.lighterRed,
    borderRadius: "6px",
    padding: "18px 24px",
    margin: "20px 0",
    minWidth: "400px",
}));

export const ValidationIcon = styled(Box)(({ theme, passed }) => ({
    width: 32,
    height: 32,
    borderRadius: "4px",
    background: passed ? theme.palette.jigsaw.green : theme.palette.jigsaw.red,
    color: theme.palette.jigsaw.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 22,
    marginRight: 18,
}));

export const ValidationTextContainer = styled(Box)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
});

export const ValidationTitle = styled(Box)(() => ({
    fontWeight: 700,
    fontSize: "18px",
    fontFamily: "Roboto",
    marginBottom: 2,
}));

export const ValidationSubtitle = styled(Box)(({ theme }) => ({
    fontWeight: 400,
    fontSize: "14px",
    color: theme.palette.jigsaw.grey,
    fontFamily: "Roboto",
}));

export const ViewDetailsButton = styled(Box)(({ theme }) => ({
    marginLeft: "auto",
    color: theme.palette.jigsaw.blue,
    fontWeight: 500,
    fontSize: "15px",
    cursor: "pointer",
    textDecoration: "underline",
    alignSelf: "center",
    padding: "6px 12px",
    borderRadius: "4px",
    "&:hover": {
        background: theme.palette.jigsaw.hoverBlue,
    },
}));

export const CategoryExpandCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== "isFirst"
})(({ theme, isFirst }) => ({
    borderTop: isFirst ? `2px solid ${theme.palette.jigsaw.darkGrey}` : undefined,
    borderBottom: `2px solid ${theme.palette.jigsaw.darkGrey}`,
    padding: 0,
    background: theme.palette.jigsaw.lightGrey,
    width: 48,
}));

export const CategoryHeaderCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== "isFirst"
})(({ theme, isFirst }) => ({
    borderTop: isFirst ? `2px solid ${theme.palette.jigsaw.darkGrey}` : undefined,
    borderBottom: `2px solid ${theme.palette.jigsaw.darkGrey}`,
    padding: 0,
    background: theme.palette.jigsaw.lightGrey,
}));

export const CategoryHeaderBox = styled(Box)(({color }) => ({
    display: "flex",
    alignItems: "center",
    fontWeight: 700,
    fontSize: 18,
    color,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 10,
    paddingBottom: 10,
    width: "100%",
    letterSpacing: 0.2,
}));

export const CategoryName = styled("span")(({ color }) => ({
    fontWeight: 700,
    fontSize: 18,
    marginRight: 18,
    color,
    textTransform: "none"
}));

export const CategoryStats = styled("span")(({ color }) => ({
    fontWeight: 700,
    fontSize: 16,
    color,
    marginRight: 16
}));

export const CategoryIcon = styled("span")({
    display: "flex",
    alignItems: "center"
});

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
    cursor: "pointer",
    float: "right",
    color: theme.palette.jigsaw.darkGrey,
    marginLeft: theme.spacing(2),
}));

export const CategoryStatusIcon = styled("span")(({ theme, color }) => ({
    display: "flex",
    alignItems: "center",
    color,
    marginLeft: theme.spacing(1),
}));

export const DataStatusIcon = styled("span")(({ color }) => ({
    display: "flex",
    alignItems: "center",
    color,
}));